module.exports = __webpack_public_path__ + "img/cross.530618d2.svg";